export default __webpack_public_path__ + "static/media/Typeform-Blog-BlackFriday-Cover-AskAwesomely.e53d930c.png";